import { CmsApiTwoTilesBlockData } from 'modules/cms/api/types/CmsApiTwoTiles';
import { CmsBlockWidth } from 'modules/cms/api/types/CmsBlockWidth';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';

import { CmsAmpTwoTilesBlock } from './CmsAmpTwoTilesBlock';
import { CmsTwoTilesBlock } from './CmsTwoTilesBlock';

export const CmsTwoTilesBlockMapping: CmsBlockMapping<CmsApiTwoTilesBlockData> =
  {
    invariant: [
      {
        prop: 'tileOneHeadline',
        msg: 'Tile One Heading required for Two Tiles',
      },
      {
        prop: 'tileTwoHeadline',
        msg: 'Tile Two Heading required for Two Tiles',
      },
    ],
    width: CmsBlockWidth.GRID,
    Component: CmsTwoTilesBlock,
    AmpComponent: CmsAmpTwoTilesBlock,
  };
